import styles from "./LookLabel.scss";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { StylingLook } from "../../types/productTypes/stylingLookProduct";

interface LookLabelProps {
  look: StylingLook;
}

const LookLabel = ({ look }: LookLabelProps) => {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };

  const labelText = look?.labelTranslationKey
    ? getTranslation(look.labelTranslationKey)
    : null;

  if (!labelText) {
    return null;
  }

  return (
    <div className={styles.lookLabelWrapper}>
      <span className={styles.lookLabel} data-testid="lookLabel">
        {labelText}
      </span>
    </div>
  );
};

export default LookLabel;
